module.exports = __webpack_public_path__ + "img/ic_order_plus.df2ea1bc.svg";